export default "__VITE_ASSET__drjcXbwt__"